import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { Svg, Polygon, Text, StyleSheet } from '@react-pdf/renderer';
;
export const BorderPolygon = memo(({ border = 'top', }) => {
    const blue = '#2d65a2';
    const orange = '#e5762c';
    const styles = StyleSheet.create({
        top: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
        },
        bottom: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
        footerText: {
            fontSize: 11,
        },
    });
    const isTop = border === 'top';
    const [svgProps, polygonProps] = useMemo(() => {
        const svgProps = {
            style: styles.bottom, height: '200', width: '1000',
        };
        const polygonProps = {
            points: '0,200 0,175 150,150 600,175 600,200',
            fill: orange,
            stroke: orange,
            strokeWidth: 1,
        };
        if (isTop) {
            svgProps.style = styles.top;
            svgProps.height = '100';
            polygonProps.points = '0,0 0,25 475,50 600,25 600,0';
            polygonProps.fill = blue;
            polygonProps.stroke = blue;
        }
        return [svgProps, polygonProps];
    }, [border]);
    return (_jsxs(Svg, { ...svgProps, children: [_jsx(Polygon, { ...polygonProps }), !isTop &&
                _jsxs(_Fragment, { children: [_jsx(Text, { x: 120, y: 175, fill: '#fff', style: styles.footerText, children: "KeySourceUSA.com" }), _jsx(Text, { x: 375, y: 155, fill: orange, style: styles.footerText, children: "7820 Palace Drive, Cincinnati, OH 45249" })] })] }));
});
